import * as Sentry from '@sentry/react'
import type { AnalyticsEvent, ConsentEventName } from './analytics'

const CONSENT_ANALYTICS_CATEGORY = 'consent_analytics'

function breadcrumbLevel(name: ConsentEventName): 'info' | 'warning' {
  if (name.endsWith('_failed') || name.endsWith('_error') || name === 'consent.session_timeout') {
    return 'warning'
  }
  return 'info'
}

// Routes consent analytics to Sentry as breadcrumbs (Replay Activity + Issue context).
// Swap this file to change the analytics backend.
export const sentryAnalyticsProvider = (event: AnalyticsEvent): void => {
  Sentry.addBreadcrumb({
    category: CONSENT_ANALYTICS_CATEGORY,
    message: event.name,
    level: breadcrumbLevel(event.name),
    timestamp: event.timestamp / 1000,
    data: {
      flow_version: event.flowVersion,
      mode: event.mode,
      session_id: event.sessionId,
      session_count: event.sessionCount,
      ...event.payload,
    },
  })
}
